<template>
	<section>
		<app-actions
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<br>
			<v-stepper v-model="step" non-linear class="accountant-steps">
			<v-stepper-header>
				<div class="stepper-header-container stepper__header justify-center">
					<v-stepper-step :step="1" :complete="step > 1" color="#02979b">Principal</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step :step="2" :complete="step > 2">Estadisticas</v-stepper-step>
				</div>
			</v-stepper-header>
			<v-stepper-items>
				<v-stepper-content step="1">
					<step-question
						:open-dialog="openDialog"
						@following-question="followingQuestion"
					></step-question>
				</v-stepper-content>
			</v-stepper-items>
			</v-stepper>
	</section>
</template>

<script>
import appActions from '@/components/shared/app-actions/app-actions';
import stepQuestion from '@/components/accountant/step-question';

function backStep() {
	this.step -= 1;
}

function closeDialog() {
	this.openDialog = false;
}

function runAction({ codeWeb }) {
	this.goTo(codeWeb);
}
function nextStep(finish) {
	if (finish) {
		this.savePlan();
	} else {
		this.step += 1;
	}
}
function followingQuestion() {
	this.goTo('statistics');
}

function data() {
	return {
		step: 1,
		openDialog: null,
	};
}

export default {
	name: 'main',
	components: {
		appActions,
		stepQuestion,
		closeDialog,
	},
	data,
	methods: {
		nextStep,
		runAction,
		backStep,
		followingQuestion,
	},
};
</script>
<style lang="scss" scoped>
.slider-list {
	font-family: font(AvenirRegular) !important;
	font-size: size(small11) !important;
	padding-left: 38px;
	padding-right: 28px;
	@media (max-width: 768px) {
		padding-left: 10px;
		padding-right: 10px;
	}
}
.sliderDinamic {
	@include flex-between;
	.clients {
			width: 64px;
			height: 21px;
			flex-grow: 0;
			font-family: DMSans;
			font-size: 16px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: left;
			color: #06152b;
	};
	.titleModule {
			width: 64px;
			height: 21px;
			flex-grow: 0;
			font-family: DMSans;
			font-size: 20px;
			font-weight: bold;
			font-stretch: normal;
			font-style: normal;
			line-height: normal;
			letter-spacing: normal;
			text-align: left;
			color: #06152b;
	};
}
.accountant-steps {
	.stepper__header {
		background-color: color(group);
		border-bottom: 3px solid color(silver-detail-table);
		border-top: 3px solid color(silver-detail-table);
		box-shadow: none;
		height: 56px;
		@include flex-center;
		&-start {
			@include flex-center;
		}
		&-height {
			border-bottom: 0px;
			height: 40px;
		}

		&.stepper-header-container {
			background-color: transparent;
			border: 0px;
			height: auto;
			margin: 0px auto;
			width: 100%;
			@include flex-between;
			@media (min-width: 900px) {
				max-width: 848px;
			}
			.stepper__step {
				padding: 0px 8px;
				&__step {
					border: 0px;
					box-shadow: 0 1px 4px 0 rgba(148, 148, 148, 0.5);
					display: none;
				}
			}

			.stepper__label {
				color: #9ca6b0 !important;
				display: flex !important;
				font-family: font(open-semibold);
				font-size: size(small);
				text-shadow: none !important;
			}

			.divider {
				background: #d2d2d2 !important;
				height: 2px;
				margin: 0px;
				max-width: 36px;
			}

			.stepper__label {
				color: #d2d2d2 !important;
			}

			.stepper__step--complete {
				.stepper__step__step {
					display: inline-flex;
					background-color: color(background-sidebar) !important;
					margin-right: 8px !important;
				}

				.stepper__label {
					color: color(background-sidebar) !important;
					font-family: font(open-bold);
				}

				& + .divider {
					background: color(primary) !important;
				}
			}

			.stepper__step--active {
				.stepper__label {
					color: color(primary) !important;
					font-family: font(open-bold);
				}

				&.stepper__step--active-border {
					border-bottom: 4px solid color(primary) !important;
				}
			}
		}
	}

	.stepper__content {
		background-color: color(maki-white);
		min-height: calc(100vh - 148px);
		padding: 0px;
	}

	.accountant-switch {
		&.input-group.input-group--selection-controls.switch {
			.input-group--selection-controls__container {
				color: #d2d2d2 !important;
			}

			.input-group--selection-controls__toggle {
				background-color: transparent !important;
				border: 1px solid currentColor !important;
				height: 15px !important;
				width: 35px !important;
			}

			.input-group--selection-controls__ripple {
				color: #d2d2d2 !important;

				&:after {
					background-color: currentColor !important;
					box-shadow: none !important;
					height: 15px !important;
					width: 18px !important;
				}
			}

			&.input-group--dirty.success--text {
				.input-group--selection-controls__container,
				.input-group--selection-controls__ripple {
					color: color(success) !important;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/main/page-main.vue